import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useSessionStore } from '@/stores/SessionStore'
import { useCachedFetch } from '@/composables/useFetch'

import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $BASEURL } = useConfigurationGlobals()

export let useBulletinStore = defineStore('bulletinStore', () => {
  const sessionStore = useSessionStore();

  const bulletinsData = ref(null);

  const bulletins = computed(() => bulletinsData.value.bulletins || []);
  const hasBulletins = computed(() => bulletinsData.value && bulletins.value.length > 0)

  async function getBulletins(lat, lon) {
    const settings = {
      lat,
      lon,
      wf_token: sessionStore.token,
    }

    const queryString = new URLSearchParams(settings).toString()
    const url = `${$BASEURL}/bulletins/getBulletins?${queryString}`

    try {
      const { error, data, isLoading } = await useCachedFetch(url)

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }

      bulletinsData.value = data.value;

      return bulletins.value
    } catch (error) {
      console.warn(error)

      return error
    }
  }

  return {
    bulletinsData,
    bulletins,
    hasBulletins,
    getBulletins
  }
})
